module.exports = __webpack_public_path__ + "img/product-banner.ef5b094f.webp";